import {
  Button,
  Pagination,
  Popconfirm,
  Spin,
  Table,
  Tag,
  Input,
  message,
  Switch,
  Select,
  Flex,
  Card,
  Modal,
  Dropdown,
  Space,
  AutoComplete,
  Form,
} from "antd";
import React, { useEffect, useState } from "react";
import { ExtractDate, ExtractTime, filterOption, messageConfiguration } from "../../../utils";
//   import {
//     updateActivationStatus,
//   } from "./orderapiFunctions";
import { getVendorsDetails, getrestroList, getordersDetails } from "../../../ApiServices/Apifun";
import {
  DeleteOutlined,
  DownOutlined,
  LoadingOutlined,
  PlusCircleOutlined,
  PlusOutlined,
  RestFilled,
  UserOutlined,
} from "@ant-design/icons";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import ComponentTitle from "../../../Common/ComponentTitle";
import { render } from "@testing-library/react";
import errorImage from "../../../assets/images/food.png"
import { MdOutlineRestore, MdResetTv, MdRestore } from "react-icons/md";


const OrderDetails = () => {

  const [orderData, setorderData] = useState([]);
  const [vendorData, setVendorData] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = useState(false); // Loading state
  const [pageSize, setPageSize] = useState(9);
  const [totalPages, setTotalPages] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [action, setAction] = useState("");
  const [VendorId, setVendorId] = useState(undefined);
  const [searchTerm, setSearchTerm] = useState("");
  const { Search } = Input;
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const from = location.state?.from;
  // console.log(from);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedOrderDetails, setSelectedOrderDetails] = useState([]);
  // Open Modal with Details
  console.log(selectedOrderDetails);
  const handleViewDetails = (details) => {
    setSelectedOrderDetails(details);
    setIsModalOpen(true);
  };

  // Close Modal
  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedOrderDetails([]);
  };

  const FetchVendorsDetails = (page) => {
    setLoading(true);
    getrestroList()
      .then((response) => {
        if (response.status) {
          setVendorData(
            response.data.map((i) => ({
              label: i.name,
              value: i.id,
            }))
          );

          // setVendorData(response.data?.vendor || []);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching vendor details:", err);
        setLoading(false);
      });
  };

  const FetchordersDetails = (page) => {
    setIsLoading(true);
    getordersDetails(`?page=${page}&limit=${pageSize}&${VendorId && `restaurantId=${VendorId}` }`)
      .then((response) => {
        if (response.status) {
          setorderData(response.data.orders || []);
          setCurrentPage(response.data.pagination.currentPage || 1);
          setTotalPages(response.data.pagination.totalPages || 0);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching order details:", err);
        setIsLoading(false);
      });
  };
  const handlePageChange = (page) => {
    setCurrentPage(page); // Update state to trigger useEffect
  };

  // function changeActiveStatus(checked, record) {
  //   console.log(checked, record);
  //   const isDeleteAction = checked === undefined;

  //   let payload = {
  //     name: record.name,
  //     is_active: isDeleteAction ? (checked ? "1" : "0") : record.is_active,
  //     is_deleted: isDeleteAction ? "0" : "1",
  //   };

  //   updateActivationStatus(payload, record.id)
  //     .then((response) => {
  //       if (response.data.status === "success") {
  //         const updatedorderTable = orderData.map((item) =>
  //           item.id === record.id
  //             ? {
  //               ...item,
  //               is_active: isDeleteAction
  //                 ? item.is_active
  //                 : payload.is_active,
  //             }
  //             : item
  //         );
  //         setorderData(updatedorderTable);
  //         FetchordersDetails(currentPage);
  //         message.open(
  //           messageConfiguration(
  //             "success",
  //             isDeleteAction
  //               ? "Category deleted successfully."
  //               : response.message,
  //             3
  //           )
  //         );
  //         if (!isDeleteAction) {
  //           FetchordersDetails(currentPage);
  //         }
  //       }
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //       message.open(
  //         messageConfiguration(
  //           "error",
  //           isDeleteAction
  //             ? "Failed to delete category."
  //             : "Failed to update status.",
  //           3
  //         )
  //       );
  //     });

  // }

  const handleErrorImage = (e) => {

    e.target.src = errorImage

  }
  // console.log("tottaaaaaaaaaaal", totalPage);
  const setwithdrawAction = (id, value) => {
    setAction((prevAction) => ({
      ...prevAction,
      [id]: value,
    }));
  };

  useEffect(() => {
    FetchordersDetails(currentPage);
    FetchVendorsDetails();
  }, [currentPage, searchTerm, VendorId]);


  const columnReports = [
    {
      title: "User Name",
      dataIndex: "username",
      key: "username",
      className: "custom-header",
      render: (data, record) => {
        return (
          <>
            <p className="text-xs font-poppins">
              {record.username?.toUpperCase() ?? "--"}
            </p>
          </>
        );
      },
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      className: "custom-header",
      render: (data, record) => {
        return (
          <>
            <p className="text-xs font-poppins">{record.email ?? "--"}</p>
          </>
        );
      },
    },
    {
      title: "PaymentMethod",
      dataIndex: "paymentMethod",
      key: "paymentMethod",
      className: "custom-header",
      render: (data, record) => {
        return (
          <>
            <p className="text-xs font-poppins">{record.paymentMethod ?? "--"}</p>
          </>
        );
      },
    },
    {
      title: "Status",
      dataIndex: "isActive",
      key: "isActive",
      className: "custom-header",
      render: (data, record) => {
        return record.isActive ? (
          <Tag
            style={{
              fontWeight: "bold",
              color: "green",
              backgroundColor: "#e0f5f0",
              borderColor: "lightgreen",
              borderRadius: "0px",
            }}
          >
            Active
          </Tag>
        ) : (
          <Tag
            style={{
              fontWeight: "bold",
              color: "red",
              backgroundColor: "#FFE1E1",
              borderColor: "pink",
              borderRadius: "0px",
            }}
          >
            InActive
          </Tag>
        );
      },
    },
    {
      title: "Created Time",
      dataIndex: "register_date",
      key: "register_date",
      className: "custom-header",
      render: (data, record) => {
        return (
          <>
            <p className="text-xs font-poppins">
              {ExtractDate(record.createdAt)}.{ExtractTime(record.createdAt)}
            </p>
          </>
        );
      },
    },
    {
      title: "Action",
      dataIndex: "status",
      key: "status",
      className: "custom-header",
      render: (data, record) => {
        return (
          <div>
            <Select
              disabled={record.isRejected === "1" || record.isApproved === "1"}
              placeholder={
                record.isRejected === "1"
                  ? "Rejected"
                  : record.isApproved === "1"
                    ? "Approved"
                    : "Select "
              }
              style={{
                width: 120,
              }}
              onChange={(value) => setwithdrawAction(record.id, value)}
              value={action[record.id]}
            >
              <Select.Option value="approve">Approved</Select.Option>
              <Select.Option value="reject">Rejected</Select.Option>
            </Select>
            {action[record.id] === "reject" && (
              <Popconfirm
                title={
                  <div>
                    <p style={{ marginBottom: "8px", fontWeight: "bold" }}>
                      Are you sure to reject this request?
                    </p>
                  </div>
                }
                // onConfirm={() => changeRequestStatus("reject", record)}
                okText="Yes"
                cancelText="Cancel"
              >
                <Button type="link">Submit</Button>
              </Popconfirm>
            )}
            {action[record.id] === "approve" && (
              <Popconfirm
                title={
                  <div>
                    <p style={{ marginBottom: "8px", fontWeight: "bold" }}>
                      Are you sure to approve this request?
                    </p>
                  </div>
                }
                // onConfirm={() => changeRequestStatus("approve", record)}
                okText="Yes"
                cancelText="Cancel"
              >
                <Button type="link" size="small">
                  Submit
                </Button>
              </Popconfirm>
            )}
          </div>
        );
      },
    },
  ];
  const dataSource = [
    {
      key: "1",
      name: "Mike",
      age: 32,
      address: "10 Downing Street",
      date: "15 December, 2020",
    },
    {
      key: "2",
      name: "John",
      age: 42,
      address: "10 Downing Street",
      date: "15 December, 2020",
    },
    {
      key: "3",
      name: "John",
      age: 42,
      address: "10 Downing Street",
      date: "15 December, 2020",
    },
    {
      key: "4",
      name: "John",
      age: 42,
      address: "10 Downing Street",
      date: "15 December, 2020",
    },
    {
      key: "5",
      name: "John",
      age: 42,
      address: "10 Downing Street",
      date: "15 December, 2020",
    },
  ];

  const columns = [
    {
      title: "Image",
      dataIndex: "imageUrl",
      key: "imageUrl",
      className: "custom-header",
      render: (text) => {
        return (
          <>
            <p className="font-medium w-[120px]">
              <img src={text} onError={handleErrorImage} crossOrigin="anonymous" />
            </p>
          </>
        );
      },
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      className: "custom-header ",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      className: "custom-header whitespace-nowrap",
      render: (text) => {
        return (
          <>
            <p className="font-medium w-[120px]">
              {text ? text : "-"}
            </p>
          </>
        );
      },
    },
    {
      title: "Price",
      dataIndex: "totalBasePrice",
      key: "totalBasePrice",
      className: "custom-header",
      render: (text) => {
        return (
          <>
            <p className="font-medium w-[120px]">
              {text ? text : "-"}
            </p>
          </>
        );
      },
    },
    {
      title: "Payment Method",
      dataIndex: "paymentMethod",
      key: "paymentMethod",
      className: "custom-header",
      render: (data, record) => {
        return (
          <>
            <p className=" bg-green-500 text-center font-bold text-base text-white p-2">{record.paymentMethod ?? "--"}</p>
          </>
        );
      },
    },
    {
      title: "Created Time",
      dataIndex: "register_date",
      key: "register_date",
      className: "custom-header",
      render: (data, record) => {
        return (
          <>
            <p className="text-xs">
              {ExtractDate(record.createdAt)}.{ExtractTime(record.createdAt)}
            </p>
          </>
        );
      },
    },
    {
      title: "OrderStatus",
      dataIndex: "is_active",
      key: "is_active",
      className: "custom-header",
      render: (data, record) => {
        return (
          <>
            <p className=" font-bold ">{record.orderStatus ?? "--"}</p>
          </>
        );
      },
    },
    {
      title: "kitchen Instruction",
      dataIndex: "is_active",
      key: "is_active",
      className: "custom-header",
      render: (data, record) => {
        return (
          <>
            <p className=" ">{record.kitchenInstruction ?? "--"}</p>
          </>
        );
      },
    },
  ];
  const detailColumns = [
    {
      title: "Food Variant Name", dataIndex: "foodVariantName", key: "foodVariantName",
      render: (text) => {
        return (
          <>
            <p className="font-medium w-[120px]">
              {text ? text : "-"}
            </p>
          </>
        );
      },

    },
    { title: "Quantity", dataIndex: "quantity", key: "quantity" },
    { title: "Base Price", dataIndex: "foodBasePrice", key: "foodBasePrice" },
    { title: "Variant Price", dataIndex: "foodVariantPrice", key: "foodVariantPrice" },
    { title: "Total Price (After Tax)", dataIndex: "total_item_price_after_tax", key: "total_item_price_after_tax" },
    {
      title: "Is Veg",
      dataIndex: "is_veg",
      key: "is_veg",
      render: (isVeg) => (
        <Tag color={isVeg ? "green" : "red"}>{isVeg ? "Veg" : "Non-Veg"}</Tag>
      ),
    },
  ];
  const items = [
    {
      key: '1',
      label: (
        <Link to={"/profile"}  >
          View Profile
        </Link>
      ),
    },
    {
      key: '2',
      label: (
        <Link to={"/myorders"}  >
          Your Orders
        </Link>
      ),
    },
  ];
  return (
    <div>
      <div className="  m-2">
        <Form className="flex justify-between" >
          <Form.Item
            name={`name`}
            label={"Select Vendor Name"}
            labelCol={{ span: 24 }}
            rules={[
              {
                required: true,
                message: "Select one name!",
              },
            ]}
          >
            <Select
              showSearch
              labelInValue={true}
              onChange={(e) => setVendorId(e.value)}
              placeholder="Select with restaurant name "
              filterOption={filterOption}
              className="w-full mt-2"
              options={vendorData}
            />
          </Form.Item>
          <div className="flex justify-center gap-2 items-center">

            {/* <Button
              type="primary"
              className="mt-4"
              onClick={() => FetchordersDetails(currentPage)} // Pass order details to modal
            >
              Search
            </Button> */}
            <button
              type="reset"

              className="mt-4 p-2 text-white rounded-md bg-primary"
              onClick={() => { setVendorId(undefined) }} // Pass order details to modal
            >
              Reset
            </button>

          </div>
        </Form>


        {/* <Search
          placeholder="search user by name..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{ width: "26%" }}
        /> */}
      </div>

      <div className="shadow-sm shadow-gray-300 p-4">
        {/* Header Section */}
        {/* <div className="flex justify-end mb-4">
          <Button
            onClick={() => setOpenModal(true)}
            className="bg-rgbaprimary8 text-white font-semibold rounded-none h-10"
          >
            <PlusOutlined /> Add Order Data
          </Button>
        </div> */}

        {/* Loading Spinner */}
        {isLoading ? (
          <div className="flex justify-center items-center h-40">
            <Spin size="large" />
          </div>
        ) : (

          <div className="grid grid-cols-1 relative sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {/* Map through orderData */}
            {orderData.length < 1 &&
              <p className="text-center  absolute left-[50%] top-[-9px] " >No Data</p>
            }
            {Array.isArray(orderData) && orderData.map((order) => (
              <div
                key={order.id}
                className="border border-gray-200 bg-white shadow-md rounded-md p-4 flex flex-col justify-between"
              >
                <div>
                  <h3 className="font-bold text-lg mb-2">Order No: {order.id}</h3>
                  <p className="text-gray-600 mb-2">
                    <strong>Restaurant Name:</strong> {order.restaurants.name}
                  </p>
                  <p className="text-gray-600 mb-2">
                    <strong>Status:</strong>{" "}
                    <Tag color={order.orderStatus === "prepared" || order.orderStatus === "completed" ? "green" : order.orderStatus === "waiting" ? "yellow" : "red"}>
                      {order.orderStatus}
                    </Tag>
                  </p>
                  <p className="text-gray-600 mb-2">
                    <strong>Price:</strong> ₹{order.totalBasePrice}
                  </p>
                  <p className="text-gray-600">
                    <strong>Total:</strong> ₹{order.totalPriceAfterTax}
                  </p>
                </div>
                {/* <Button
                  type="primary"
                  className="mt-4 bg-primary w-full"
                  onClick={() => handleViewDetails(JSON.parse(order.foodItemDetails))} // Pass order details to modal
                >
                  View Details
                </Button> */}
                {/* Modal */}
                <Modal
                  title="Order Details"

                  open={isModalOpen}
                  onCancel={handleCloseModal}
                  width="700px"
                  footer={[
                    <Button key="close" onClick={handleCloseModal}>
                      Close
                    </Button>,
                  ]}
                >
                  <Table
                    className="history-table animate-fade-in max-h-[500px]  overflow-x-auto text-white rounded-lg"
                    dataSource={selectedOrderDetails}
                    columns={detailColumns}
                    pagination={false}
                    bordered={true}
                    size="small"
                  />
                </Modal>
              </div>

            ))}

          </div>
        )}
      </div>
      <Pagination
        className="mt-2 text-xs w-full flex justify-end"
        total={totalPages * 9} // Assuming 10 items per page
        showTotal={(total, range) =>
          `${range[0]}-${range[1]} of ${totalPages * 9} items`
        }
        onChange={handlePageChange}
        defaultPageSize={pageSize}
        current={currentPage}
      />

    </div>
  );
};
export default OrderDetails;
